/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_Cancel_FailedInputs */

const en_settings_billing_cancel_failed = /** @type {(inputs: Settings_Billing_Cancel_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to cancel subscription`)
};

/**
* | output |
* | --- |
* | "Failed to cancel subscription" |
*
* @param {Settings_Billing_Cancel_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_billing_cancel_failed = /** @type {((inputs?: Settings_Billing_Cancel_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Cancel_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_billing_cancel_failed(inputs)
});
export { settings_billing_cancel_failed as "settings.billing.cancel_failed" }